import React, { useContext } from 'react';
import LineworxClient from '../lineworxClient';
import {
  LineworxStateContext,
  LineworxDispatchContext
} from '../context/LineworxContext';
import Cookies from 'universal-cookie';

// Import module css
import styles from './Login.module.css';

const Login = () => {
  const context = useContext(LineworxStateContext);
  const dispatch = useContext(LineworxDispatchContext);
  const state = context.login;

    const forgotPassword = async () => {
        if(state.name.length < 2) {
          dispatch({section: 'login', type: 'error', payload: true});
          return ;
        }

        dispatch({section: 'login', type: 'loading', payload: true});

        await LineworxClient.forgotPassword(state.name);

        dispatch({section: 'login', type: 'loading', payload: false});
        dispatch({section: 'login', type: 'showForgot', payload: !state.showForgot});
        
        alert("Check your email for a link to reset your password");
    };

    const login = async () => {
        if(state.name.length < 2 || state.password.length<4) {
          dispatch({section: 'login', type: 'error', payload: true});
          return;
        }
        
        dispatch({section: 'login', type: 'loading', payload: true});
        console.log(state)
        let resp = await LineworxClient.login(state.name, state.password);
        dispatch({section: 'login', type: 'loading', payload: false});
        
        if(resp.response.status === 403) {
          dispatch({section: 'login', type: 'error', payload: true});
        }
        else if(resp.response.status === 400) {
          alert("Account has not been verified, check your email for a link to set your password");
        }
        else if(resp.response.status === 200) {
            const user = resp.body;
            sessionStorage.setItem('user', user);
            const cookies = new Cookies();
            cookies.set("lineworx_token", user.token);
            window.location.href = '/jobs'
            //props.history.push('/jobs');
        }
    };

    return (
        <div className="container-fluid d-flex flex-column align-items-center justify-content-center section login-page">
          
          <div className={`position-relative ${styles.loginContainer}`}>
            <div className="login-logo">
                <svg width="300" height="300" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg" className={"login-logo-image " + (state.loading?"login-logo-image-loading" : "")}>
                    <path fillRule="evenodd" clipRule="evenodd" d="M117.236 117.564L135.488 51.7447C92.1144 58.0338 57.8376 92.408 51.6958 135.829L27.8827 142.432C31.5571 80.9652 80.6763 31.7417 142.099 27.9031L149.836 0L149.836 27.6621V50.7138L149.836 149.836L150 150L182.436 117.564L247.963 135.734C241.785 92.3581 207.526 58.0292 164.185 51.7447L157.574 27.9031C218.965 31.7398 268.066 80.9159 271.784 142.34L300 150.164L150.164 150.164L182.436 182.436L164.279 247.914C207.349 241.626 241.429 207.643 247.863 164.621L271.742 158C267.712 219.081 218.792 267.897 157.666 271.763L149.836 300L149.836 272.01V248.959L149.836 150.491L117.564 182.764L51.7948 164.526C58.1928 207.593 92.292 241.622 135.393 247.914L142.006 271.763C80.8492 267.895 31.9107 219.032 27.9244 157.907L0 150.164L27.6625 150.164H50.7143L149.836 150.164L117.236 117.564Z" fill="#FFCC18"/>
                </svg>
            </div>
            <div className="reveal logo-text">
                <svg className="slide" width="369" height="53" viewBox="0 0 369 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.893466 52H33.4822V43.1257H11.657V1.09091H0.893466V52ZM51.3738 1.09091H40.6103V52H51.3738V1.09091ZM102.811 1.09091H92.0973V33.108H91.6499L69.6754 1.09091H60.2294V52H70.9929V19.9581H71.3658L93.5142 52H102.811V1.09091ZM111.704 52H146.107V43.1257H122.468V30.9702H144.243V22.0959H122.468V9.9652H146.008V1.09091H111.704V52ZM166.025 52H176.515L186.185 18.7152H186.582L196.277 52H206.767L221.334 1.09091H209.576L201.149 36.5384H200.702L191.43 1.09091H181.362L172.065 36.4638H171.643L163.216 1.09091H151.458L166.025 52ZM271.006 26.5455C271.006 9.89062 260.665 0.394884 247.167 0.394884C233.595 0.394884 223.329 9.89062 223.329 26.5455C223.329 43.1257 233.595 52.696 247.167 52.696C260.665 52.696 271.006 43.2003 271.006 26.5455ZM260.094 26.5455C260.094 37.3338 254.973 43.1754 247.167 43.1754C239.337 43.1754 234.241 37.3338 234.241 26.5455C234.241 15.7571 239.337 9.91548 247.167 9.91548C254.973 9.91548 260.094 15.7571 260.094 26.5455ZM278.979 52H289.743V33.9531H297.598L307.243 52H319.125L308.312 32.2131C314.104 29.7273 317.31 24.6811 317.31 17.7209C317.31 7.60369 310.624 1.09091 299.065 1.09091H278.979V52ZM289.743 25.3026V9.89062H297.001C303.216 9.89062 306.224 12.6499 306.224 17.7209C306.224 22.767 303.216 25.3026 297.051 25.3026H289.743ZM335.009 1.09091H322.804L338.44 26.5455L322.506 52H334.835L345.276 34.6243H345.673L356.114 52H368.493L352.609 26.5455L368.145 1.09091H355.989L345.673 18.4418H345.276L335.009 1.09091Z" fill="#FFCC18"/>
                </svg>
            </div>
            <div className={`login-input-div ${styles.loginFormInputDiv}`}>
                <div className={`login-input-inner-div ${styles.loginFormInner}`}>
                    <span className={`login-input-label ${styles.loginFormLabel}`}>Email</span>
                    <input onChange={(e) => dispatch({section: 'login', type: 'name', payload: e.target.value})} className={`login-input ${styles.loginFormInput}`} disabled={state.loading}/>
                    <span className={`login-input-label ${styles.loginFormLabel}`}>Password</span>
                    <input type="password" onChange={(e) => dispatch({section: 'login', type: 'password', payload: e.target.value})} className={`login-input ${styles.loginFormInput}`}  disabled={state.loading}/>
                    {state.error &&  <span className="error-label" >Username or Password is incorrect<br/></span>}
                    <div className={`btn-action full-width ${styles.loginFormSubmit}`}>
                        <button type="button" className={`btn btn-warning text-white full-width ${styles.loginFormBtn}`}  disabled={state.loading} onClick={login}>
                            <div className={`d-flex ${styles.loginFormBtnCopy}`}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="currentColor"
                                    className="bi bi-plus"
                                    viewBox="0 0 16 16" />
                                <span>Login</span>
                            </div>
                        </button>
                    </div>
                    <a
                        className={`forgot-password ${styles.loginFormForgot}`}
                        href="#"
                        onClick={() => dispatch({section: 'login', type: 'showForgot', payload: !state.showForgot})}
                    >
                        Forgot Password
                    </a>
                </div>
            </div>
          </div>

            {state.showForgot &&
              <div id="pwdModal" className={`modal ${styles.modalPwd}`} style={{display:"unset"}} tabIndex="-1" role="dialog" >
                <div className={`modal-dialog modal-lg modal-dialog-centered ${styles.modalDialog}`}>
                  <div className="modal-content">
                    <fieldset>

                      {/* MODAL HEADER */}
                      <div className={`modal-header ${styles.modalHeader}`}>
                        <h5 className={`modal-title text-center ${styles.modalTitle}`}>What&apos;s My Password?</h5>
                        <button type="button" className={`close ${styles.modalHeaderClose}`} onClick={() => dispatch({section: 'login', type: 'showForgot', payload: !state.showForgot})} aria-hidden="true">×</button>
                      </div>
                    
                      {/* MODAL BODY */}
                      <div className={`modal-body ${styles.modalBody}`}>
                        <div className="col-md-12">
                          <div className="panel panel-default">
                            <div className="panel-body">
                              <div className="text-center">
                                <p className={styles.modalBodyDirections}>If you have forgotten your password you can reset it here.</p>
                                
                                <div className="panel-body">
                                  <div className={`form-group ${styles.modalBodyFormGroup}`}>
                                      <input
                                        className={`form-control input-lg ${styles.modalBodyInput}`}
                                        placeholder="E-mail Address"
                                        name="email"
                                        type="email"
                                        value={state.name}
                                        onChange={(e) => dispatch({section: 'login', type: 'name', payload: e.target.value})} />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* MODAL FOOTER */}
                      <div className={`modal-footer b-0 ${styles.modalFooter}`}>
                        <div className="row m-0 w-100">
                          <div className="col-md-12 d-flex flex-column flex-sm-row justify-content-sm-end">
                            <button
                              className={`btn btn-secondary mb-3 mb-sm-0 ${styles.modalFooterButton}`}
                              data-dismiss="modal"
                              aria-hidden="true"
                              onClick={() => dispatch({section: 'login', type: 'showForgot', payload: !state.showForgot})}
                            >
                              Cancel
                            </button>

                            <input
                              className={`btn btn-lg btn-primary btn-block my-0 ml-0 ml-sm-4 mr-0 ${styles.modalFooterButton} ${styles.modalFooterSubmit}`}
                              value="Send My Password"
                              type="submit"
                              onClick={forgotPassword} />
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            }
        </div>

    );
}

export default Login;
